/* PagingSiteFeed.js */

const PagingFeed = require("../../../../lib/PagingFeed");

class PagingSitesFeed extends PagingFeed {
    _getFeed() {
        return this._EntityDef.startSitesFeed(this._activeOrgId, this._filter, this._entityFields, this._sort, {
            skip: 0,
            limit: this._pageSize * 2
        });
    }

    _getDistinctValuesOfField(tenantId, field) {
        return this._EntityDef.startSiteDistinctValuesFeed(tenantId, field);
    }

    _getFeedIdsForSelection(tenantId, selection) {
        return this._EntityDef.loadDeviceIdsForSelection(tenantId, selection);
    }

    getSiteEntitiesById(ids) {
        return this.getEntitiesById(ids);
    }

    getSiteEntitiesNameById(ids) {
        return this.getEntitiesNameById(ids);
    }

    getSiteEntityById(id) {
        return this.getEntityById(id);
    }
}

module.exports = PagingSitesFeed;
